import * as Phaser from "phaser";
import { SettingsGlobalPlugin } from "$/game/plugins/SettingsGlobalPlugin.ts";
import { assets, atlases, audiosprites, scenes } from "$/keys";
import { strings } from "$/keys/strings";

export class KeysManagerGlobalPlugin extends Phaser.Plugins.BasePlugin {
  private settings!: SettingsGlobalPlugin;
  public strings!: typeof strings["en" | "ru"];
  public assets: typeof assets = assets;
  public scenes: typeof scenes = scenes;
  public atlases: typeof atlases = atlases;
  public audiosprites: typeof audiosprites = audiosprites;

  /** Shortcut for main atlas key */
  public get atlas(): string {
    return atlases.main.key;
  }

  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
    this.settings = pluginManager.game.plugins.get(
      "settings",
    ) as SettingsGlobalPlugin;

    this.strings =
      strings[this.settings.getSetting("language") as keyof typeof strings];
  }
}
